import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LineChart, Briefcase, User, Newspaper, MessageCircle } from 'lucide-react';

function BottomNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Admin ve Login sayfalarında gösterme
  const hiddenPaths = ['/admin', '/login', '/register', '/manager'];
  const shouldHide = hiddenPaths.some(path => location.pathname.startsWith(path));
  
  if (shouldHide) return null;
  
  // Aktif sayfa kontrolü
  const isActive = (path) => {
    if (path === '/trading') {
      return location.pathname === '/trading' || location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  const navItems = [
    { path: '/trading', icon: LineChart, label: 'İşlem' },
    { path: '/positions', icon: Briefcase, label: 'Pozisyon' },
    { path: '/profile', icon: User, label: 'Profil' },
    { path: '/news', icon: Newspaper, label: 'Haberler' },
    { path: '/support', icon: MessageCircle, label: 'Destek' },
  ];

  return (
    <>
      {/* Spacer - Alt navigasyon için boşluk bırakır */}
      <div 
        style={{ 
          height: 'calc(70px + env(safe-area-inset-bottom, 20px))',
          minHeight: '90px'
        }} 
      />
      
      {/* Fixed Bottom Navigation */}
      <nav 
        className="fixed left-0 right-0 bg-gray-900 border-t border-gray-700"
        style={{ 
          bottom: 0,
          zIndex: 99999,
          paddingBottom: 'max(env(safe-area-inset-bottom, 0px), 10px)',
          paddingTop: '8px',
          boxShadow: '0 -4px 20px rgba(0,0,0,0.5)'
        }}
      >
        <div className="max-w-7xl mx-auto px-2">
          <div className="grid grid-cols-5 gap-1">
            {navItems.map((item) => {
              const Icon = item.icon;
              const active = isActive(item.path);
              
              return (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  className={`flex flex-col items-center justify-center py-2 rounded-lg transition-all duration-200 ${
                    active 
                      ? 'bg-blue-600/20 text-blue-400' 
                      : 'text-gray-400 hover:bg-gray-800 hover:text-white'
                  }`}
                >
                  <Icon size={24} className="mb-1" />
                  <span className="text-xs font-medium">{item.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </nav>
    </>
  );
}

export default BottomNavigation;
